import React from 'react';
import {T} from '../../../utils/I18n/I18n';
import dayjs from '../../../utils/date';
import {priceNumberFormatter} from '../../../utils/price';
import {isHR} from '../../../utils/isHr';
import hidePriceSkus from '../../../utils/hidePriceSkus';
import './AnchorPrices.scss';

const AnchorPrices = ({product}) => {
    if (!isHR || !product || hidePriceSkus.includes(product.sku)) {
        return null;
    }

    const anchors = [1, 2]
        .map((instance) => ({price: product[`anchor${instance}_price`], date: product[`anchor${instance}_date`]}))
        .filter(({price, date}) => price != null && date);

    if (anchors.length == 0) {
        return null;
    }

    return (
        <div className='anchor-prices'>
            {anchors.map(({price, date}, index) => (
                <div key={index}>
                    <T id="product.anchorPrice" date={dayjs(date).format('D.M.YYYY')} price={priceNumberFormatter(price)}/>
                </div>
            ))}
        </div>
    );
};

export default AnchorPrices;
